import { render, staticRenderFns } from "./MindsDashboard.vue?vue&type=template&id=9b0c0fe2&scoped=true"
import script from "./MindsDashboard.vue?vue&type=script&lang=js"
export * from "./MindsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MindsDashboard.vue?vue&type=style&index=0&id=9b0c0fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0c0fe2",
  null
  
)

export default component.exports